
<template>
  <b-modal
      @hidden='displayTab = true; cleanForm()'
      ref="compute-lt-kanban-be-modal"
      hide-footer
      hide-header
      size="lg"
  >
    <div class="d-block">
      <h4>Calcule de leadtime sur une période</h4>
      <br>
      <b-container fluid>
        <div  v-if="!display_result" class="form-compute-block"> 
          <b-row>
            <b-col sm="4">
              <label>Du :</label>
            </b-col>
            <b-col sm="8">
              <b-form-input type="date" v-model="form.start_date"></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="4">
              <label>Au :</label>
            </b-col>
            <b-col sm="8">
              <b-form-input type="date" v-model="form.end_date" ></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="4">
              <label>Type d'affaire :</label>
            </b-col>
            <b-col sm="8">
              <b-form-group>
                <b-form-radio-group
                  id="btn-radios-2"
                  v-model="form.internal_kanban"
                  :options="case_type_options"
                  buttons
                  button-variant="outline-primary"
                  size="md"
                  @change="typeChanged"
                  name="radio-btn-outline"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <label>Type de commande :</label>
            </b-col>
            <b-col sm="8">
              <b-form-select v-model="form.kanban_type" :options="kanban_type_options" :state="!isEmpty(form.kanban_type)"></b-form-select>
            </b-col>
          </b-row>
          <br>
          <b-row v-if="form.kanban_type == 'Opportunité'">
            <b-col sm="4">
              <label>Version :</label>
            </b-col>
            <b-col sm="8">
              <b-form-group>
                <b-form-radio-group
                  id="btn-radios-2"
                  v-model="form.kanban_version"
                  :options="kanban_version_options"
                  buttons
                  button-variant="outline-primary"
                  size="md"
                  @change="versionChanged"
                  name="radio-btn-outline"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div v-if="display_result" class="leadtime-result-block">
          <div class="icon-check">
            <i class="fa fa-check-circle"></i>
          </div>
          <h2 stryle="font-weigh:normal;">Lead time</h2>
          <br>
          <span>Du {{form.start_date}} au {{form.end_date}}</span>
          <br>
          <span><b>Kanban {{form.internal_kanban ? 'interne' : 'externe' }} - {{form.kanban_type}}</b></span> <br>
          <span>Version {{form.kanban_version}}</span>
          <br><br>
          <div>
            <span> Min : <b>{{leadtime_compute.min}} J</b> - </span>
            <span> Moyenne : <b>{{leadtime_compute.mean}} J</b> - </span>
            <span> Max : <b>{{leadtime_compute.max}} J</b> </span>
          </div>
          <div>Nombre de kanban comptés <b>{{leadtime_compute.count}}</b></div>
        </div>
        <hr>
        <div v-if="!display_result" style="overflow:auto;">
          <div style="float:right;">
            <b-button
              class="mt-3"
              variant="primary"
              @click="computeLeadTime()"
            >
              Calculer
            </b-button>
          </div>
        </div>
        <div v-else style="overflow:auto;">
          <div style="float:right;">
            <b-button
              class="mt-3"
              variant="primary"
              @click="hideModal()"
            >
              Terminer
            </b-button>
          </div>
        </div>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import server from '../../api/server.vue'
import BadErpStockCard from '../andon/BadErpStockCard.vue';

export default {
  components: { BadErpStockCard },
  name: 'PeriodComputeLTModal',
  data() {
    return {
      loading: false,
      form:{
        start_date: '',
        end_date: '',
        internal_kanban: false,
        kanban_type: '',
        kanban_version: 1,
      }, 
      kanban_type_options: [
        { value: null, text: 'Sélectionner une option'},
        { value: 'Pré-étude', text: 'Pré étude'},
        { value: 'Commande', text: 'Commande'},
        { value: 'Livrable', text: 'Livrable'},
        { value: 'Opportunité', text: 'Opportunité'},
        { value: 'Trading', text: 'Trading'}
      ],
      case_type_options: [
        { text: 'Interne', value: true}, 
        { text: 'Externe', value: false}
      ],
      kanban_version_options:[
        { text: 'Version 1', value: 1},
        { text: 'Version 2', value: 2},
      ],
      leadtime_compute: 0,
      display_result: false,
    }
  },
  methods: {
    isEmpty (value) {
      return _.isEmpty(value)
    },
    hideModal () {
      this.cleanForm()
      this.display_result = false
      this.$refs['compute-lt-kanban-be-modal'].hide()
    },
    showModal () {
      this.$refs['compute-lt-kanban-be-modal'].show()
    },
    computeLeadTime () {
      this.loading = true
      if (this.checkValidityPeriod (this.form.start_date, this.form.end_date)) {
        server.computeLeadtimeMeanOnPeriod(this.form).then(res => {
          this.leadtime_compute = res.data
          this.loading = false
          this.display_result = true
        }).catch((error) => {
          this.$toasted.error(`Mince ! Une erreur <br> ${error}`)
        })
      }
      else {
        this.$toasted.error('Vérifier les champs et la cohérence des dates')
      }
    },
    cleanForm () {
      this.form.start_date = ''
      this.form.end_date = ''
      this.form.internal_kanban = false
      this.form.kanban_type = ''
      this.form.kanban_version = 0

    },
    checkValidityPeriod (start_date, end_date) {
      if (!this.isEmpty(start_date) && !this.isEmpty(end_date)){
        if (start_date > end_date) {
          return false
        } else {
          return true
        }
      }
      return false
    },
    typeChanged (newType) {
      
    },
    versionChanged (newValue) {
      
    }
  },
  mounted: function() {
  },
};
</script>

<style>
input.invalid {
  background-color: #ffdddd;
}

select.invalid {
  background-color: #ffdddd;
}

.leadtime-result-block {
  text-align: center;
}

.icon-check {
  font-size: 8rem;
  text-align: center;
  color: #3174ad;
}

</style>


// WEBPACK FOOTER //
// src/components/modal/PeriodComputeLTModal.vue